export default __webpack_public_path__ + "static/media/slab4.bdbd5fb9.png";